import ArrowLeftIcon from './arrow-left-icon';
export default ArrowLeftIcon;
